/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useState } from 'react';
import { usePlayFlag } from './../../components/topicScroll';
import ImgPoint from '../../../../../assets/animation_point.gif';

import './animation046.less';

interface IAnimation046SubItem {
  img: string;
  title: string;
  content: string;
}
interface IAnimation046Item {
  img1: string;
  img2: string;
  text: string;
  subtitle?: string;
  subItems?: IAnimation046SubItem[];
}

interface IAnimation046Props {
  items: IAnimation046Item[];
  tipText: string;
  tipImg: string;
  className?: string;
  onCompleted?: () => void;
}

const Animation046: React.FunctionComponent<IAnimation046Props> = ({
  items,
  tipText,
  tipImg,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const startPlay = (next = 2) => {
    setPlay(next);
    next === 2 ? (next += 2) : (next += 1);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1500);
    } else {
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag && play <= 1) {
      startPlay();
    }
  }, [playFlag]);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const clickToPlay = () => {
    if (play <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className={`animation046 component ${className || ''}`}>
      <img
        className="click-point1"
        onClick={() => clickToPlay()}
        style={{
          display: play <= 1 ? 'block' : 'none',
        }}
        src={ImgPoint}
        alt=""
      />
      {items.map((itm: IAnimation046Item, idx: number) =>
        itm.text ? (
          <div key={idx} className="animation046-contaner">
            <div
              key={`item ${idx}`}
              onClick={() => clickToPlay()}
              className={`animation046-item r${idx + 1} animation ${
                play >= idx + 1 ? 'fade-in' : ''
              }`}
            >
              <img
                src={
                  windowWidth > 1500 || windowWidth <= 1024
                    ? require(`../../../../../assets/${itm.img1}`).default
                    : require(`../../../../../assets/${itm.img2}`).default
                }
                alt=""
              />
              <div className="text">
                <div dangerouslySetInnerHTML={{ __html: itm.text }} />
              </div>
            </div>
          </div>
        ) : (
          <div key={idx} className="animation046-contaner">
            <div className="force-wrap"></div>
          </div>
        )
      )}
    </div>
  );
};

export default Animation046;
